import React, { useEffect, useState } from "react"
import C3Chart from "react-c3js"
import "c3/c3.css"

// Takes `reviews` from the parent instead of fetching independently - see
// ReviewsSummary.js for why.
const DonutChart = ({ reviews = [] }) => {
  const [chartData, setChartData] = useState([])

  useEffect(() => {
    const ratingsDistribution = [1, 2, 3, 4, 5].map(rating => {
      const count = reviews.filter(
        review => Number(review.rating) === rating,
      ).length
      return [`${rating} Stars`, count]
    })

    setChartData(ratingsDistribution)
  }, [reviews])

  const data = {
    columns: chartData,
    type: "donut",
  }

  const donut = {
    title: "Ratings Distribution",
    width: 30,
    label: { show: false },
  }

  const color = {
    pattern: ["#A7D3FF", "#6BB8FF", "#2990DF", "#1E73C9", "#155EAB"],
  }

  const size = {
    height: 300,
  }

  return (
    <React.Fragment>
      <C3Chart data={data} donut={donut} color={color} size={size} dir="ltr" />
    </React.Fragment>
  )
}

export default DonutChart
